export default __webpack_public_path__ + "static/media/add-shopping-cart-grey.0eea8585.svg";